import axios from 'axios';

export const getAddressByZipCode = async (zipCode) => {
  const url = `${process.env.REACT_APP_API_URL}/google_maps/zip_code/${zipCode}/`;

  return axios.get(url);
};
